import { useAuth } from "hooks/useAuth";
import useScreen from "hooks/useScreen";
import { Navigate, Outlet } from "react-router-dom";

export const AuthGuard = () => {
  const { isAuthenticated } = useAuth();


  let content;

  if (isAuthenticated) {
    content = <Outlet />;
  } else {
    content = <Navigate to="/fin" />;
  }

  return content;
};
